import { IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { FeatureDetailState } from "../types";

export const deselectAllFeaturesPartialReducer: IPartialReducer<FeatureDetailState> = (state, action) => {
    return {
        features: [],
    };
};
